import { Link } from "@tanstack/react-router";
import { cn } from "@theprelude/core";
import { Button, PlusIcon } from "@theprelude/ds";
import { Node, NodeProps, Position } from "@xyflow/react";
import { tb, tn } from "@/lib/tracking";
import { NoControlsDataPoint } from "@/queries/control-monitor";
import { ConnectionIndicator } from "../connection-indicator";
import { useControlMonitorNavigation } from "../control-monitor-navigation";
export type NoControlsNodeType = Node<
  NoControlsDataPoint,
  NoControlsDataPoint["type"]
>;

export const NoControlsNode = ({ data }: NodeProps<NoControlsNodeType>) => {
  const { path } = useControlMonitorNavigation();
  const isExpanded = path.includes(data.id);

  return (
    <div
      data-type="react-flow-node"
      className={cn("flex h-full items-center", tn("connect-integration"))}
    >
      <div className="absolute left-0 top-0 font-serif text-3xl">
        {data.name}
      </div>
      <Link
        to="/account/integrations"
        onClick={(event) => event.stopPropagation()}
      >
        <Button
          intent="primary"
          icon={<PlusIcon />}
          className={tb("connect-an-integration")}
        >
          Connect an integration
        </Button>
      </Link>
      <ConnectionIndicator
        type="target"
        position={Position.Left}
        isConnected={isExpanded}
        disabled={!data.enabled}
      />
    </div>
  );
};
